/**
 * Create a page for all wpPage nodes automatically via
 * filesystem routing: https://www.gatsbyjs.com/docs/reference/routing/file-system-route-api/
 */
import * as React from "react"
import { graphql } from "gatsby"
import MainLayout from "../layouts/main"
import flatListToHierarchical from "../utils/flat-list-to-hierarchical"
import { UserInterfaceContext } from "../context/UserInterfaceContext"
import WordpressContent from "../components/wordpress-content"
import findLocalMenu from "../utils/find-local-menu-item"
import makeProdUrl from "../utils/make-prod-url"

interface IPageProps {
  data: Queries.PageContentQuery
}

export default function Page(props: IPageProps): JSX.Element {
  const page = props.data.wpPage
  const { setCurrentPost } = React.useContext(UserInterfaceContext)
  const menuItems = flatListToHierarchical(props.data.allWpMenuItem.nodes)
  const fields = JSON.parse(page?.customFieldsJson ?? `{}`)
  const hideBreadcrumbs = fields?.hide_breadcrumbs ?? false

  // console.log(`page`, { uri: page.uri, databaseId: page.databaseId })

  const localMenuItem = page?.localParentId
    ? findLocalMenu(page?.localParentId, menuItems)
    : null

  // TODO: set currentPost with pageContext to see if it prevents null on load
  React.useEffect(() => {
    setCurrentPost(page)
  }, [props.data])

  const html =
    page?.content
      ?.replace(
        /\/wp-content\/themes\/georgian\/blocks\/src\/imgs\/choosemore(\-mobile)?\.jpg/gim,
        `https://content.georgiancollege.ca/wp-content/themes/georgian/blocks/src/imgs/choosemore$1.jpg`
      )
      .replace(
        /href="https:\/\/(www.georgiancollege.ca|www.gcblueprint.local|georgiangatsby.wpengine.com|georgiandevenv.wpengine.com|content.georgiancollege.ca)\//gim,
        `href="/`
      ) || ``

  return (
    <>
      {/* <Seo
        title={page?.seo?.title || page?.title}
        description={page?.seo?.metaDesc}
        jsonld={page?.seo?.schema?.raw}
      /> */}
      <MainLayout
        localMenuItem={localMenuItem}
        breadcrumbs={hideBreadcrumbs ? null : page?.breadcrumbs}
      >
        {page?.content?.indexOf(`wp-block`) === -1 && (
          <h1 className="text-4xl mb-4 text-blue">{page?.title}</h1>
        )}
        <WordpressContent
          html={html}
        // program={{ partTimePage: page.partTimePage, ...page?.program }}
        />

      </MainLayout>
    </>
  )
}

// configure page, for example set defer to use DSG
// export async function config() {
//   // Optionally use GraphQL here
//   return ({ params }) => {
//     return {
//       defer: true,
//     }
//   }
// }

export const Head = ({
  data,
}: {
  data: Queries.PageContentQuery
}): JSX.Element => (
  <>
    <meta key="PageID" name="PageID" content={data?.wpPage?.databaseId} />
    <title id="page-title">
      {data?.wpPage?.seoTitle ? data.wpPage.seoTitle : data.wpPage.title}
    </title>
    <meta name="description" content={data?.wpPage?.seoDesc} />
    {data?.wpPage?.seoSchema && (
      <script type="application/ld+json">
        {makeProdUrl(data.wpPage.seoSchema)}
      </script>
    )}
  </>
)

export const query = graphql`
  query PageContent($uri: String!) {
    wpPage(uri: { eq: $uri }) {
      id
      title
      content
      uri
      databaseId
      topParentId
      localParentId
      breadcrumbs
      customFieldsJson
      seoTitle
      seoDesc
      seoSchema
      programCode
      partTimePage
      program {
        programCode
        title
        courseList {
          courseId
          title
          courseData {
            dataSource
            uri
            wpEquivalencies {
              equivalentCourse {
                courseId
                courseCode
                courseNumber
                title
                uri
              }
            }
          }
        }
      }
    }
    allWpMenuItem(filter: { locations: { in: LOCAL_MENU } }) {
      ...LocalMenuItemFields
    }
  }
`
